export default "__VITE_ASSET__CqLPghqw__"